<span class="option-text" ngClass="{'active', active}">
  <input *ngIf="_multiple" class="form-check-input" type="checkbox" [checked]="selected" [disabled]="disabled" />
  <ng-content></ng-content>
</span>
<ng-content select=".option-icon-container"></ng-content>
